module.exports = __webpack_public_path__ + "static/male-man-73b83c95f5a67501b41a5617122c4d60.png";